export const columns = ({ t }) => [
  {
    title: t('Batch #'),
    name: 'remittanceBatchId'
  },
  {
    title: t('Carrier'),
    name: 'carrierName'
  },
  {
    title: t('Processed On'),
    name: 'createdLocal'
  },
  {
    title: t('Total Invoiced'),
    name: 'totalAmountDue'
  },
  {
    title: t('# of Invoices'),
    name: 'invoiceCount'
  }
];
export const dateColumns = ['createdLocal'];
export const currencyColumns = ['totalAmountDue'];
export default {
  columns,
  currencyColumns,
  dateColumns
};
